export enum WorkersCompCode {
  Unknown = 0,
  ShortHaul = 7228,
  LongHaul = 7229,
  Office = 8810
}

export const WorkersCompCodeMapping: Record<WorkersCompCode, string> = {
  [WorkersCompCode.Unknown]: 'N/A',
  [WorkersCompCode.ShortHaul]: '7228: LH: Short',
  [WorkersCompCode.LongHaul]: '7229: LH: Long',
  [WorkersCompCode.Office]: '8810: Clerical'
};


export const WorkersCompCodeCodeMapping: Record<WorkersCompCode, string> = {
  [WorkersCompCode.Unknown]: '0',
  [WorkersCompCode.ShortHaul]: '7228: LH: Short',
  [WorkersCompCode.LongHaul]: '7229: LH: Long',
  [WorkersCompCode.Office]: '8810: Clerical'
};